export const CHATS_NOTIFICATION_EXPERIMENT = 'aud_all_platform_new_notification';

export const EXPERIMENTS = [CHATS_NOTIFICATION_EXPERIMENT];
